var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { TemplateState } from '@debbie/common/dist/templates';
import { c } from '@debbie/cortex/dist';
import * as templatesAPI from '@debbie/cortex/dist/api/templates';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors';
import { selectMe } from '@debbie/cortex/dist/me/selectors';
import { Edit, PlusCircle } from '../../Icons';
import { Badge, Button, ButtonGroup, Input, Modal, PlaceholderLoader, } from '../..';
import THEME from '../../../theme';
import { parseText, PARSE_RESULT_TYPE } from '../../../utils/templates';
import { TypeStyled } from '../Templates';
const Header = (props) => {
    var _a;
    const { defaultTemplate, template } = props;
    const lang = useSelector((s) => s.lang);
    const me = useSelector(selectMe);
    const exclusiveContent = useSelector(selectExclusiveContent);
    const [state, setState] = useState({
        loadingSaveDraft: false,
        loadingPublishVersion: false,
    });
    const [savingAndPublishing, setSavingAndPublishing] = useState(false);
    const [savingDraft, setSavingDraft] = useState(false);
    const [publishing, setPublishing] = useState(false);
    const [editNameModalOpen, setEditNameModalOpen] = useState(false);
    const getCurrentTemplate = () => {
        return Object.assign(Object.assign({}, template), { public: undefined, subject: parseText(draftToHtml(convertToRaw(props.subjectState.getCurrentContent())), lang.mentions, PARSE_RESULT_TYPE.TEXT), text: parseText(draftToHtml(convertToRaw(props.editorState.getCurrentContent())), lang.mentions, PARSE_RESULT_TYPE.TEXT), html: parseText(draftToHtml(convertToRaw(props.editorState.getCurrentContent())), lang.mentions), intent: props.intent });
    };
    const saveAndPublish = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(Object.assign(Object.assign({}, state), { loadingSaveDraft: true }));
        setSavingAndPublishing(true);
        const newVersion = yield save();
        yield publish(newVersion.versionId);
        setState(Object.assign(Object.assign({}, state), { loadingSaveDraft: false }));
        props.setTemplate(Object.assign(Object.assign({}, getCurrentTemplate()), { state: TemplateState.DRAFT, versionId: newVersion.versionId }));
        setSavingAndPublishing(false);
    });
    const saveDraftOnly = () => __awaiter(void 0, void 0, void 0, function* () {
        setSavingDraft(true);
        const newVersion = yield save();
        props.setTemplate(Object.assign(Object.assign({}, getCurrentTemplate()), { state: TemplateState.DRAFT, versionId: newVersion.versionId }));
        setSavingDraft(false);
    });
    const publishOnly = () => __awaiter(void 0, void 0, void 0, function* () {
        setPublishing(true);
        if (template.versionId) {
            publish(template.versionId);
        }
        props.setTemplate(Object.assign(Object.assign({}, getCurrentTemplate()), { state: TemplateState.PUBLISHED, versionId: template.versionId }));
        setPublishing(false);
    });
    const save = () => __awaiter(void 0, void 0, void 0, function* () {
        const newVersion = template &&
            (yield templatesAPI.saveDraft(Object.assign(Object.assign({}, getCurrentTemplate()), { isDefaultLang: props.selectedLanguage === template.lang && template.isDefaultLang, lang: props.selectedLanguage })));
        return newVersion;
    });
    const publish = (versionId) => __awaiter(void 0, void 0, void 0, function* () {
        setState(Object.assign(Object.assign({}, state), { loadingPublishVersion: true }));
        console.log({ versionId });
        try {
            const _versionId = versionId || (template === null || template === void 0 ? void 0 : template.versionId);
            _versionId &&
                (yield templatesAPI.publishVersion(_versionId, props.ac, props.selectedLanguage === template.lang && template.isDefaultLang));
            yield c.templates.getAll();
            props.setTemplate(Object.assign(Object.assign({}, getCurrentTemplate()), { state: TemplateState.PUBLISHED }));
        }
        catch (error) {
            alert(error);
        }
        setState(Object.assign(Object.assign({}, state), { loadingPublishVersion: false }));
    });
    return (React.createElement(StyledHeader, null,
        defaultTemplate &&
            (!defaultTemplate.public ||
                (me && (exclusiveContent === null || exclusiveContent === void 0 ? void 0 : exclusiveContent.includes(me.id)))) && (React.createElement(ButtonGroup, { style: {
                float: 'right',
            } },
            React.createElement(Button, { size: "small", disabled: !(props.changesNotSaved || template.versionId === null), onClick: saveAndPublish, loading: savingAndPublishing }, lang.templates.saveAndPublish),
            React.createElement(Button, { size: "small", 
                // disabled={
                //   props.subjectValidationErrors.length > 0 ||
                //   props.editorValidationErrors.length > 0
                // }
                theme: "secondary", onClick: () => props.toggleModal('preview') }, lang.templates.preview),
            React.createElement(Button, { size: "small", theme: "secondary", dropdown: [
                    {
                        value: lang.templates.versions,
                        theme: 'secondary',
                        onClick: () => {
                            props.toggleModal('versions');
                        },
                    },
                    {
                        value: lang.templates.saveDraft,
                        theme: 'secondary',
                        onClick: () => {
                            saveDraftOnly();
                        },
                    },
                    {
                        value: lang.templates.publish,
                        theme: 'secondary',
                        onClick: () => {
                            publishOnly();
                        },
                    },
                    {
                        value: lang.templates.copyOtherTemplate,
                        theme: 'secondary',
                        onClick: () => props.toggleModal('copyTemplate'),
                    },
                    {
                        value: lang.templates.settings,
                        theme: 'secondary',
                        onClick: () => props.toggleModal('settings'),
                    },
                ], dropdownLeft: true }))),
        React.createElement("h1", null,
            !defaultTemplate || props.loading ? (React.createElement(PlaceholderLoader, null)) : (defaultTemplate.name),
            ' ',
            !(defaultTemplate === null || defaultTemplate === void 0 ? void 0 : defaultTemplate.public) && (React.createElement(Edit, { style: {
                    width: '16px',
                    cursor: 'pointer',
                }, onClick: () => {
                    setEditNameModalOpen(!editNameModalOpen);
                } }))),
        (defaultTemplate === null || defaultTemplate === void 0 ? void 0 : defaultTemplate.name) && editNameModalOpen && (React.createElement(Modal, { onToggle: () => {
                setEditNameModalOpen(!editNameModalOpen);
            }, header: defaultTemplate.name },
            React.createElement(EditName, { templateId: props.templateId, name: defaultTemplate.name, onDone: (name) => {
                    props.setTemplate(Object.assign(Object.assign({}, getCurrentTemplate()), { name }));
                    setEditNameModalOpen(!editNameModalOpen);
                } }))),
        React.createElement("p", null,
            defaultTemplate && (React.createElement(TypeStyled, { type: defaultTemplate.type }, defaultTemplate.type)),
            ' ',
            defaultTemplate &&
                defaultTemplate.createdAt &&
                `${lang.templates.lastChangedOn} ${moment(defaultTemplate.createdAt).format(THEME.DATE_FORMAT_LONG)}`,
            ' ',
            !(defaultTemplate === null || defaultTemplate === void 0 ? void 0 : defaultTemplate.public) && (React.createElement(PlusCircle, { "data-tooltip-content": lang.templates.addTag, "data-tooltip-id": "tooltip-default", style: { verticalAlign: 'text-top' }, onClick: () => props.toggleModal('addTag') })),
            ' ',
            !!((_a = defaultTemplate === null || defaultTemplate === void 0 ? void 0 : defaultTemplate.tags) === null || _a === void 0 ? void 0 : _a.length) &&
                defaultTemplate.tags.map(({ tag }) => (React.createElement(Badge, { key: tag, theme: THEME.COLOR_ACCENT, style: { marginRight: '2px' } }, lang.templateTags[tag]))),
            React.createElement("span", { style: { float: 'right', minWidth: '20%', textAlign: 'right' } }, savingAndPublishing || savingDraft || publishing ? (React.createElement(PlaceholderLoader, null)) : (React.createElement(React.Fragment, null, defaultTemplate &&
                (defaultTemplate.state === TemplateState.VERSION ||
                    defaultTemplate.state === TemplateState.DRAFT)
                ? `${lang.templates.WIP}`
                : defaultTemplate &&
                    defaultTemplate.state === TemplateState.PUBLISHED
                    ? `${lang.templates.versionPublished}`
                    : ''))))));
};
export default Header;
const StyledHeader = styled.div `
  h1 {
    font-size: 2.5em;
    margin-bottom: 0;
  }

  p {
    color: ${THEME.DARK_COLOR_SECONDARY};
    font-weight: bold;
    font-size: 0.9em;
  }
`;
const EditName = (props) => {
    const lang = useSelector((s) => s.lang);
    const [name, setName] = useState(props.name);
    return (React.createElement("div", null,
        React.createElement(Input, { placeholder: lang.templates.name, value: name, onChange: (e) => setName(e.target.value), autofocus: true, onSubmit: name != props.name && name
                ? () => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        yield templatesAPI.patch(props.templateId, {
                            name,
                        });
                        props.onDone(name);
                    }
                    catch (error) {
                        alert('Error');
                    }
                })
                : undefined })));
};
//# sourceMappingURL=Header.js.map